function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(2.000000, 1.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 4,
  className: "signature"
}, React.createElement("path", {
  d: "M146,77 C137,63.5835531 102.285298,61.5716057 66,77 C29.7147022,92.4283943 -5.12208759,121.408434 1,126 C5,129 43.9913242,98.6607126 77,61 C96.0821743,39.2285032 119.762223,2.46529951 115,1 C106.517341,-1.61004907 76.6031417,82.634784 87,115 C92.5367246,132.235715 111.025103,113.209453 119,105 C141.950154,81.3748413 155,41 146,39 C137,37 119.876691,74.1290255 119,85 C118.123309,95.8709745 115.763795,114.960632 128,117 C140.236205,119.039368 180,78 173,73 C169.634542,70.5961013 148.686355,87.1792651 151,100 C153.27895,112.628475 158.000213,110.60877 162,112 C170.060467,114.803641 197,85 195,85 C193,85 197.782052,110.775263 211,103 C224.217948,95.2247366 237,79 219,89 C201,99 173,119.623407 151,141",
  id: "Path"
}), React.createElement("path", {
  d: "M243,50 C248.333333,43.3333333 252,39.3333333 254,38 C257,36 238,48.4018773 238,47 C238,45.5981227 273,25 281,23 C289,21 257,93 245,110 C233,127 257,82 270,65 C283,48 298,28 305,30 C312,32 277,99 280,108 C283,117 305,90 299,88 C293,86 285.928686,103 286,107 C286.071314,111 288.071314,115.255816 301,109 C313.928686,102.744184 326,84 332,71 C338,58 338,47 332,49 C326,51 322,59 317,69 C312,79 309,99 309,109 C309,119 315.443413,113 322,107 C328.556587,101 340.893878,89.8510204 346,89 C351.106122,88.1489796 353.725563,96 351,102 C348.274437,108 342,113.204898 339,113.204898 C336,113.204898 322,109 322,107 C322,105 366.811924,97 372,97 C377.188076,97 357,107 360,111 C363,115 389,100.014043 387,92 C385,83.9859567 371.341933,100.014043 376,97 C380.658067,93.9859567 398,93 403,89 C408,85 387,105 389,107 C391,109 415.715745,92.4105319 419,92 C422.284255,91.5894681 414,100.795102 419,107 C424,113.204898 431,113 458,92 C485,71 492,61 497,56",
  id: "Path-2"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 501 144",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/signature.b42f3a4c.svg";
export { SvgComponent as ReactComponent };